import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import SalonProtectedRoute from './components/SalonProtectedRoute';
import Layout from './components/Layout';
import SalonLayout from './components/SalonLayout';
import Login from './pages/Login';
import Bookings from './pages/Bookings';
import Salons from './pages/Salons';
import Customers from './pages/Customers';
import Settings from './pages/Settings';
import Payments from './pages/Payments';
import Settlements from './pages/Settlements';
import Cities from './pages/Cities';
import PushNotifications from './pages/PushNotifications';
import WhatsAppEvents from './pages/WhatsAppEvents';
import MasterCatalog from './pages/MasterCatalog';
import SalonServicesView from './pages/SalonServicesView';
import ServiceRequests from './pages/ServiceRequests';
import ServiceRequestEditor from './pages/ServiceRequestEditor';
import Dashboard from './pages/salon/Dashboard';
import SalonBookings from './pages/salon/SalonBookings';
import SalonProfile from './pages/salon/SalonProfile';
import SalonStaffManagement from './pages/salon/SalonStaffManagement';
import SalonPayments from './pages/salon/SalonPayments';
import SalonAdvancePayments from './pages/salon/SalonAdvancePayments';
import SalonServices from './pages/salon/SalonServices';
import ManageOffers from './pages/salon/ManageOffers';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            
            {/* Admin Routes */}
            <Route path="/" element={
              <AdminProtectedRoute>
                <Layout>
                  <Navigate to="/bookings" replace />
                </Layout>
              </AdminProtectedRoute>
            } />
            <Route path="/bookings" element={
              <AdminProtectedRoute>
                <Layout>
                  <Bookings />
                </Layout>
              </AdminProtectedRoute>
            } />
            <Route path="/salons" element={
              <AdminProtectedRoute>
                <Layout>
                  <Salons />
                </Layout>
              </AdminProtectedRoute>
            } />
            <Route path="/customers" element={
              <AdminProtectedRoute>
                <Layout>
                  <Customers />
                </Layout>
              </AdminProtectedRoute>
            } />
            <Route path="/settings" element={
              <AdminProtectedRoute>
                <Layout>
                  <Settings />
                </Layout>
              </AdminProtectedRoute>
            } />
            <Route path="/payments/:salonId" element={
              <AdminProtectedRoute>
                <Layout>
                  <Payments />
                </Layout>
              </AdminProtectedRoute>
            } />
            <Route path="/settlements" element={
              <AdminProtectedRoute>
                <Layout title="Advance Pay Settlements">
                  <Settlements />
                </Layout>
              </AdminProtectedRoute>
            } />
            <Route path="/cities" element={
              <AdminProtectedRoute>
                <Layout>
                  <Cities />
                </Layout>
              </AdminProtectedRoute>
            } />
            <Route path="/master-catalog" element={
              <AdminProtectedRoute>
                <Layout title="Master Catalog">
                  <MasterCatalog />
                </Layout>
              </AdminProtectedRoute>
            } />
            <Route path="/salons/:salonId/services" element={
              <AdminProtectedRoute>
                <Layout title="Salon Services">
                  <SalonServicesView />
                </Layout>
              </AdminProtectedRoute>
            } />
            <Route path="/service-requests" element={
              <AdminProtectedRoute>
                <Layout title="Service Update Requests">
                  <ServiceRequests />
                </Layout>
              </AdminProtectedRoute>
            } />
            <Route path="/service-requests/:requestId/edit" element={
              <AdminProtectedRoute>
                <Layout title="Prepare Services">
                  <ServiceRequestEditor />
                </Layout>
              </AdminProtectedRoute>
            } />
            <Route path="/notifications" element={
              <AdminProtectedRoute>
                <Layout title="App notifications">
                  <PushNotifications />
                </Layout>
              </AdminProtectedRoute>
            } />
            <Route path="/whatsapp-events" element={
              <AdminProtectedRoute>
                <Layout title="WhatsApp Events">
                  <WhatsAppEvents />
                </Layout>
              </AdminProtectedRoute>
            } />

            {/* Salon Routes */}
            <Route path="/salon/dashboard" element={
              <SalonProtectedRoute>
                <SalonLayout>
                  <Dashboard />
                </SalonLayout>
              </SalonProtectedRoute>
            } />
            <Route path="/salon/bookings" element={
              <SalonProtectedRoute>
                <SalonLayout>
                  <SalonBookings />
                </SalonLayout>
              </SalonProtectedRoute>
            } />
            <Route path="/salon/profile" element={
              <SalonProtectedRoute>
                <SalonLayout>
                  <SalonProfile />
                </SalonLayout>
              </SalonProtectedRoute>
            } />
            <Route path="/salon/staff-management" element={
              <SalonProtectedRoute>
                <SalonLayout>
                  <SalonStaffManagement />
                </SalonLayout>
              </SalonProtectedRoute>
            } />
            <Route path="/salon/payments" element={
              <SalonProtectedRoute>
                <SalonLayout>
                  <SalonPayments />
                </SalonLayout>
              </SalonProtectedRoute>
            } />
            <Route path="/salon/advance-payments" element={
              <SalonProtectedRoute>
                <SalonLayout>
                  <SalonAdvancePayments />
                </SalonLayout>
              </SalonProtectedRoute>
            } />
            <Route path="/salon/services" element={
              <SalonProtectedRoute>
                <SalonLayout>
                  <SalonServices />
                </SalonLayout>
              </SalonProtectedRoute>
            } />
            <Route path="/salon/offers" element={
              <SalonProtectedRoute>
                <SalonLayout>
                  <ManageOffers />
                </SalonLayout>
              </SalonProtectedRoute>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

